import { useQuery, useQueryClient } from "@tanstack/react-query";
import { URL_API } from "../config/default";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AlojamientoPlaceholder from "../components/UI/Spinner/AlojamientoPlaceholder";
import { myHeaders } from "../config/axios";
import Error from "./Error/Index";
import { CustomToast } from "../utils/custom-toast";
import ExcursionCard from "../components/UI/excursion-card";
import { useAppContext } from "../contexts/AppProvider";
import useMedia from "../hooks/useMedia";
import { chunkArray } from "../utils/chunkArray";
import { SliderChunk } from "../components/UI/Home/slider-section";

const Excursiones = () => {
  const isMobile = useMedia("(max-width: 768px)", false);
  const queryClient = useQueryClient();
  const { me }: any = useAppContext();

  const setFavorito = (excursion: any, favoritos: any) => {
    let check = favoritos.data.filter(
      (f: any) => f.excursion_id == excursion.id
    );

    if (check.length > 0) {
      const requestOptions = {
        method: "DELETE",
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/favorites/${check[0].id}`, requestOptions)
        .then(async (response) => {
          await response.json();
          return CustomToast({
            status: 200,
            msg: "",
            title: "Alojamiento eliminado de favoritos",
          });
        })
        .catch((error) => console.error(error));
      queryClient.invalidateQueries({
        queryKey: ["favoritos"],
      });
      return ""
    }

    let formData = new FormData();
    formData.append("excursion_id", String(excursion.id));

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: myHeaders,
      },
    };

    fetch(`${URL_API}/favorites`, requestOptions)
      .then(async (response) => {
        if (response.ok) {
          await response.json();
          return CustomToast({
            status: 200,
            msg: "",
            title: "Excursion agregado a favoritos",
          });
        } else {
          return CustomToast({
            status: 400,
            msg: "",
            title: "Debes inicisar sesion para generar una lista de favoritos",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    queryClient.invalidateQueries({
      queryKey: ["favoritos"],
    });
  };

  /*
  const agrupar = (data: any) => {
    const groups = [];
    for (let i = 0; i < data.length; i += 4) {
      groups.push(data.slice(i, i + 4));
    }
    return groups;
  };
  */

  const filter = localStorage.getItem("filter");

  const {
    isPending: isPendingFavoritos,
    error: errorFavoritos,
    data: favoritos,
  } = useQuery({
    queryKey: ["favoritos"],
    queryFn: () => {
      const requestOptions = {
        headers: {
          Authorization: myHeaders,
        },
      };
      return fetch(`${URL_API}/favorites`, requestOptions).then((res) =>
        res.json()
      );
    },
  });

  const { isPending, error, data } = useQuery({
    queryKey: ["excursiones"],
    queryFn: () => {
      let fill = filter ? JSON.parse(filter) : "";
      const params = new URLSearchParams(fill);
      return fetch(`${URL_API}/excursions?${params}`).then((res) => res.json());
    },
  });

  if (isPending || isPendingFavoritos) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1">
        {[1, 2, 3, 4].map((index) => {
          return <AlojamientoPlaceholder key={index} />;
        })}
      </div>
    );
  }

  if (error || errorFavoritos) return <Error />;


  const chunkSize = isMobile ? 4 : 8;
  const chunkedDestinations = chunkArray(data.data, chunkSize);

  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-gray-200 px-6 py-1">
        <div className="flex items-center justify-between">
          <h1 className="md:text-sm text-nowrap lg:text-2xl font-medium text-gray-900">{data.total} Excursiones</h1>
        </div>
      </div>


      <div className="flex flex-col lg:flex-row lg:p-6">
        {chunkedDestinations.map((chunk, idx) => (
          <SliderChunk
            key={idx}
            items={chunk}
            renderCard={(destination) => (
              <ExcursionCard
                key={destination.id}
                destination={destination}
                setFavorito={setFavorito}
                favoritos={favoritos}
                user={me}
              />
            )}
          />
        ))}

      </div>
    </div>
  );
};

export default Excursiones;
